import React, { useState } from "react";
import PlantelRosterSection from "./PlantelRosterSection";

const getVariant = (position = "") => {
    const text = String(position).toLowerCase();

    if (text.includes("campe")) {
        return {
            border: "border-yellow-300/40",
            softBg: "bg-yellow-300/10",
            title: "text-yellow-300",
            badge: "bg-yellow-300 text-black",
        };
    }

    if (text.includes("segundo") || text.includes("vice")) {
        return {
            border: "border-slate-300/40",
            softBg: "bg-slate-300/10",
            title: "text-slate-200",
            badge: "bg-slate-300 text-slate-900",
        };
    }

    if (text.includes("tercer") || text.includes("3")) {
        return {
            border: "border-amber-500/40",
            softBg: "bg-amber-500/10",
            title: "text-amber-400",
            badge: "bg-amber-500 text-black",
        };
    }

    return {
        border: "border-white/10",
        softBg: "bg-green-500/10",
        title: "text-white",
        badge: "bg-white/10 text-slate-300",
    };
};

function PlantelCard({ plantel, defaultOpen = false }) {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const style = getVariant(plantel?.posicion);
    const resultadoFinal = plantel?.resultadoFinal || "";

    return (
        <div className={`rounded-xl border ${style.border} bg-white/5 backdrop-blur-xl overflow-hidden`}>
            <button
                type="button"
                onClick={() => setIsOpen((prev) => !prev)}
                className="w-full flex items-start sm:items-center justify-between px-3 py-3 sm:p-5 cursor-pointer hover:bg-white/5 transition-colors text-left gap-2"
            >
                <div className="flex items-start gap-2.5 sm:gap-4 min-w-0">
                    <div className={`size-8 sm:size-10 mt-0.5 sm:mt-1 rounded-lg shrink-0 ${style.softBg}`} />
                    <div className="min-w-0">
                        <div className="flex flex-wrap items-start sm:items-center gap-1.5 sm:gap-2">
                            <h3 className={`text-base sm:text-xl font-bold ${style.title} leading-tight break-words`}>{plantel?.torneo || "-"}</h3>
                            <span className={`px-1.5 sm:px-2 py-0.5 rounded text-[9px] sm:text-[10px] font-black uppercase tracking-wider shrink-0 max-w-full break-words ${style.badge}`}>
                                {plantel?.posicion || "Sin posición"}
                            </span>
                        </div>
                        {resultadoFinal && (
                            <p className={`text-[11px] sm:text-xs mt-0.5 sm:mt-1 font-medium uppercase tracking-tight break-words ${style.title} opacity-80`}>
                                {resultadoFinal}
                            </p>
                        )}
                    </div>
                </div>
                <span className={`text-slate-400 shrink-0 mt-1 sm:mt-0 ml-2 transition-transform duration-300 ${isOpen ? "rotate-180" : "rotate-0"}`}>▾</span>
            </button>

            <div className={`grid transition-[grid-template-rows,opacity] duration-300 ease-out ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                <div className="min-h-0 overflow-hidden">
                    <div className="px-3 pb-5 pt-3 sm:px-6 sm:pb-7 sm:pt-5 space-y-4 sm:space-y-6">
                        <PlantelRosterSection title="Mayores" players={plantel?.mayores} />
                        <PlantelRosterSection title="Extranjeros" players={plantel?.extranjeros} />
                        <PlantelRosterSection title="Sub 25" players={plantel?.sub25} />
                        <PlantelRosterSection title="Sub 23" players={plantel?.sub23} />
                        <PlantelRosterSection title="Cuerpo Técnico" players={plantel?.tecnicos} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PlantelCard;
